import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=649041d2&scoped=true&"
import script from "./Draft.vue?vue&type=script&lang=js&"
export * from "./Draft.vue?vue&type=script&lang=js&"
import style0 from "./Draft.vue?vue&type=style&index=0&id=649041d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649041d2",
  null
  
)

export default component.exports